$('.active-language-container').click(function(){
  var $dropdown = $(this).siblings('.language-selector-dropdown');
  if($dropdown.hasClass('open')){
    $dropdown.removeClass('open');
  }else{
    $('.language-selector-dropdown').removeClass('open');
    $dropdown.addClass('open');
  }
  
});

$('.language').click(function(){
  var current_path = window.location.pathname;
  var current_language = DetectCurrentLanguage();
  var selected_language = $(this).data('language');
  
  if(current_language == selected_language){ return true; }
  else{
    if(current_language != "default"){
      current_path = current_path.substring(3);
      console.log('lang current_path', current_path);
    }
    if(selected_language == "fr"){
      window.location.pathname = "/fr" + current_path;
    }else{
      
      window.location.pathname = current_path;
    }
  }
  
  $('.language-selector-dropdown').removeClass('open');
});

function DetectCurrentLanguage(){ 
  var current_path = window.location.pathname + "/";
  var arb_lang = current_path.substring(0, 4);
  
  console.log(arb_lang);
  if(arb_lang == "/fr/"){
    return "fr";
  }else{
    return "default";
  }

}

function InitLanguageSelector(){
  var fr_flag = "https://cdn.shopify.com/s/files/1/0420/7529/1814/files/france_b_w.png?v=1605874967";
  var default_flag = "https://cdn.shopify.com/s/files/1/0420/7529/1814/files/us_b_w-1.png?v=1605874974";
  var current_lang = DetectCurrentLanguage();
  var $flag_img = $('.active-language-container img');
  if(current_lang == "fr"){
  	$flag_img.attr('src', fr_flag);
  }else{
    $flag_img.attr('src', default_flag);
  }
  
  $flag_img.show();
}
InitLanguageSelector();


$('.mobile-tab h3').click(function(e){
  var $parent = $(this).parents('.mobile-tab');
  if($parent.attr('id') == "mobile-tab-description"){
    var ingredient_list = $parent.find('.ingredients-list');
    if(!ingredient_list.hasClass('init')){
    	ingredient_list.slick('refresh');
    }
    ingredient_list.addClass('init');
  }
  $parent.toggleClass('open');
  $parent.find('.mobile-tab-content').slideToggle(400);
});

$('.tab-link').click(function(){
  $('.template-ingredients').addClass('init');
  if($(this).hasClass('tab-link-description')){
    setTimeout(function(){ 
      $('.template-ingredients').removeClass('init');
    }, 300);
    
  }
});

$('.stamped-product-reviews-badge').click(function(e){
  e.preventDefault();
  e.stopPropagation();
  console.log('stamped');
  var header_height = $('#header-wrapper-custom').outerHeight();
  var offset = header_height + 100;
  $('html, body').animate({
      scrollTop: $(".stamped-container").offset().top - offset
  }, 400);
});



function CopyProductDetails(){
  var $suggested = $('.tab-content-suggested').clone();
  var $references = $('.tab-content-references').clone();
  var $ingredients = $('.tab-content-ingredients').clone();
  //var $description = $('.tab-content-description .product-template').clone();
  var $supplement = $('.tab-content-nutrition').clone();
  
  $('#mobile-tab-supplement .mobile-tab-content').html($supplement);
  //$('#mobile-tab-description .mobile-tab-content').html($description);
  $('#mobile-tab-ingredients .mobile-tab-content').html($ingredients);
  $('#mobile-tab-references .mobile-tab-content').html($references);
  $('#mobile-tab-suggested .mobile-tab-content').html($suggested);
  
  $(document).trigger('refreshScrollMagic');
  
}

$(document).ready(function(){
  if($('body').hasClass('template-product')) CopyProductDetails();
});

$('.form__wrapper').scrollToFixed( { 
  marginTop: $('#header-wrapper-custom').outerHeight(),
  minWidth: 769,
  zIndex: 999,
  limit: function() {
      var limit = $('.product-photo-wrapper').height() - $('.form__inner__wrapper').outerHeight(true);
      return limit;
   },
  
  unfixed: function(){
    var $header_wrapper = $('#header');
    $header_wrapper.addClass('bn-open');
  },
  
  preFixed: function(){
    var $header_wrapper = $('#header');
    var $buy_now_wrapper = $('.product-buy-now-wrapper');
    //make sure buy now wrapper is not visible
    if($buy_now_wrapper.hasClass('animatingS')){
      setTimeout(function(){ $header_wrapper.removeClass('bn-open'); }, 300);
    }else{
      $header_wrapper.removeClass('bn-open');
    }
  }
});


 

$('.index-cards .product-grid').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  freeScroll: false,
  pageDots: false,
  prevNextButtons: false,
  friction: 0.5,
  selectedAttraction: 0.2,
  dragThreshold: 0,
});

$('.mobile-footer-accordion').click(function(){
  $(this).toggleClass('open');
  $(this).find('.footer__quicklinks').slideToggle(400);
})


//add android class to body for backdrop filter workaround
$(function() { // Wait for page to finish loading.
    if(navigator != undefined && navigator.userAgent != undefined) {
        user_agent = navigator.userAgent.toLowerCase();
        if(user_agent.indexOf('android') > -1) { // Is Android.
            $(document.body).addClass('android');
        }
    }
});

function _debounce(func, delay){
  let inDebounce
  return function() {
    const context = this
    const args = arguments
    clearTimeout(inDebounce)
    inDebounce = setTimeout(() => func.apply(context, args), delay)
  }
}



$(function(){
	$(window).trigger('resize'); 
})


//price change listener
$('#ProductPrice-product .money').bind("DOMSubtreeModified", PriceChangeHandler);

function PriceChangeHandler(){
  var newPrice = $('#ProductPrice-product .money').text();
  $('.product-buy-now-price .money').text(newPrice);
}

//variant dropdown
$(document).on('click', '.variant-dropdown-container', function(){
    $('.variant-dropdown-na').toggle();
    $(this).toggleClass('custom-close');
  });
  
  $(document).on('click', '.variant-dropdown-na' , function(){
    var text = $(this).find('.variant-dropdown-text').text();
    var promo_text = $(this).find('.variant-dropdown-promo-text').clone();
    var dropdown_active = $('.variant-dropdown-active');
    var value = $(this).data('option');
    var selectId = $(this).closest('.variant-dropdown-container').data('target');
    dropdown_active.find('.variant-dropdown-promo-text').remove();
    dropdown_active.append(promo_text);
    dropdown_active.data('value', value);
    $('.variant-dropdown-text-active').text(text);
    
    
    $('#' + selectId).val(value);
    $('#' + selectId).trigger('change');
    console.log('select value:', $('#' + selectId).val());
  });

$(document).ready( function() {
  
  var promotionSliderWrapper = $('#shopify-section-promotion-slider');
  
  // On init
  $('.promotion-slider-container', promotionSliderWrapper).on('init', function(slick){
    //set contents to be visible
    $('.promotion-slider-container .promotion-content', promotionSliderWrapper).show();
  });
  
  //top banner slick
  $('.promotion-slider-container', promotionSliderWrapper).slick({
                  slidesToShow: 1,
    infinite: false,
                  slidesToScroll: 1,
                  prevArrow: '<a class="prev-button arrow-btn" href="#"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 20 38"><path d="M4.068 18.649l15.466 16.105c.31.283.466.629.466 1.039 0 .41-.155.77-.466 1.08a1.412 1.412 0 0 1-1.038.424c-.41 0-.756-.141-1.038-.424L.466 19.708A1.373 1.373 0 0 1 0 18.648c0-.423.155-.776.466-1.059L17.458.424A1.412 1.412 0 0 1 18.496 0c.41 0 .755.141 1.038.424.31.282.466.636.466 1.06 0 .423-.155.776-.466 1.059L4.068 18.649z" fill="#726D75" fill-rule="evenodd"/></svg></a>',
                  nextArrow: '<a class="next-button arrow-btn" href="#"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 20 38"><path d="M15.932 18.649L.466 2.543A1.35 1.35 0 0 1 0 1.505c0-.41.155-.77.466-1.081A1.412 1.412 0 0 1 1.504 0c.41 0 .756.141 1.038.424l16.992 17.165c.31.283.466.636.466 1.06 0 .423-.155.777-.466 1.06L2.542 36.872a1.412 1.412 0 0 1-1.038.424c-.41 0-.755-.141-1.038-.424A1.373 1.373 0 0 1 0 35.813c0-.423.155-.776.466-1.059L15.932 18.65z" fill="#726D75" fill-rule="evenodd"/></svg></a>',
    adaptiveHeight: true,
    autoplay: true,
  autoplaySpeed: 4000,
  })
  
 
  
  $('.ingredients-list').on('reInit', function(event, slick, direction){
    $(this).css({opacity: 1});
     console.log('fading');
      // left
    });
  
  $('.ingredients-list').on('init', function(){
    console.log('init');
    $(document).trigger('refreshScrollMagic');
  });
  
   $('.ingredients-list').slick({
    slidesToShow: 1,
    infinite: false,
    slidesToScroll: 1,
    prevArrow: '<a class="prev-button arrow-btn" href="#"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 20 38"><path d="M4.068 18.649l15.466 16.105c.31.283.466.629.466 1.039 0 .41-.155.77-.466 1.08a1.412 1.412 0 0 1-1.038.424c-.41 0-.756-.141-1.038-.424L.466 19.708A1.373 1.373 0 0 1 0 18.648c0-.423.155-.776.466-1.059L17.458.424A1.412 1.412 0 0 1 18.496 0c.41 0 .755.141 1.038.424.31.282.466.636.466 1.06 0 .423-.155.776-.466 1.059L4.068 18.649z" fill="#726D75" fill-rule="evenodd"/></svg></a>',
    nextArrow: '<a class="next-button arrow-btn" href="#"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 20 38"><path d="M15.932 18.649L.466 2.543A1.35 1.35 0 0 1 0 1.505c0-.41.155-.77.466-1.081A1.412 1.412 0 0 1 1.504 0c.41 0 .756.141 1.038.424l16.992 17.165c.31.283.466.636.466 1.06 0 .423-.155.777-.466 1.06L2.542 36.872a1.412 1.412 0 0 1-1.038.424c-.41 0-.755-.141-1.038-.424A1.373 1.373 0 0 1 0 35.813c0-.423.155-.776.466-1.059L15.932 18.65z" fill="#726D75" fill-rule="evenodd"/></svg></a>',
    adaptiveHeight: false,
    autoplay: false
  })
   
  
   
  
  
  
  
});

//ajax add to cart product grid





$(document).on('click', '.product-grid-add-js' , function(e) {
  e.preventDefault();
  var quantity = 1,
    productID = $(this).data('id'),
    collectionID = $(this).data('collection');

  var form_data = {};
  form_data["quantity"] = quantity;
  form_data["id"] = productID;
  addItem(form_data, collectionID);

});
var addItem = function(data, collectionID) {
  var root_url = window.langify.locale.root_url != '/' ? window.langify.locale.root_url : '';
  $.ajax({
    type: 'POST',
    url: root_url + '/cart/add.js',
    dataType: 'json',
    data: data,
    success: function(product){
      theme.Drawer.addToCartOkay(product, collectionID);
    },
    error: addToCartFail
  });
}


var addToCartFail = function(obj, status) {
  $('form .errors').remove();
  $('.product__add__success').addClass('product__add__success--hide');
  $( "<div class='errors'>"
      + obj.responseJSON.message
      + ': '
      + obj.responseJSON.description
      + "</div>" ).appendTo('form');
}
// product page

//APPEND Current Price to RO Widget 


$(document).ready(function(){
  
  //drawer container var
  var $drawerWrapper = $('#drawer-wrapper');

/** DRAWER **/
 $('.drawer-close', $drawerWrapper).click(function(e){
    e.preventDefault();
    theme.Drawer.closeDrawer();
    
    
    
  });


  
  $('#CartButton').click(function(e){
    e.preventDefault();
    theme.Drawer.openDrawer();
    
  });

  var cartItemChangeQty = function(data, success, fail){
    var root_url = window.langify.locale.root_url != '/' ? window.langify.locale.root_url : '';
    $.ajax({
      type: 'POST',
      url: root_url + '/cart/change.js',
      dataType: 'json',
      data: data,
      success: success
    });
    
  }


  var removeCartItem = function(cartItem){

    cartItem.animate({
      opacity: 0
    }, 300, function(){
      cartItem.remove();
    });

    theme.Drawer.cartChange(false);
      
  }
  
  $(document).on('click', '.cart-item-remove-container', function(){
    var qty = 0;
    var cartItem = $(this).parents('.cart-item');
    var key = cartItem.data('id');
    var data = { quantity: qty, id: key };
    
    cartItemChangeQty(data, removeCartItem(cartItem));
    
  });
  
  $(document).on('click', '.drawer-qty-adjust', function(e){
    e.preventDefault();
    var el = $(this),
        qtySelector = el.siblings('.js-qty__num.quantity__input'),
        qty = parseInt(qtySelector.val().replace(/\D/g, ''));
    
    var cartItem = el.parents('.cart-item');

    // Make sure we have a valid integer
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    
    if (el.hasClass('quantity__minus')) {
      qty = qty - 1;
    } else {
      qty = qty + 1;
    }
    
      qtySelector.val(qty);
      qtySelector.trigger('change');
      
  });
  
  
  
  $(document).on('change', '.js-qty__num.quantity__input', function(){
    console.log('qty_change');
    var qty = $(this).val();
    var $cartItem = $(this).parents('.cart-item');
    var key = $cartItem.data('id');
    var data = { quantity: qty, id: key };
    
    if(qty == 0){
        removeCartItem($cartItem);
      }
    
    
    cartItemChangeQty(data, function(){
      theme.Drawer.cartChange(false);
    });
    
  });
//click outside drawer hide
	$(document).on("click", function(event){
      	var $drawerWrapper = $('.drawer-wrapper');
      	
        if(!$(event.target).closest(".drawer-main").length){
          if($drawerWrapper.hasClass('open')){
            theme.Drawer.closeDrawer();
          }
        }
    });
});

$('.intercom-drawer').click(function(){
  
  var params = {
    intercom: true
  };
  theme.Drawer.closeDrawer(params);
});


$(document).ready(function(){
  var image = $('#supplement-facts-picture').data('src');
  $('#supplement-facts-picture').zoom({url: image, on: "click"});
});


$('.supplement-facts-trigger, .supplement-facts-zoom').click(function(e){
  var src = $(this).data('src');
  $('.product-mobile-zoom img').attr('src', src);
  
  var $draggable =  $('.product-mobile-zoom img').draggabilly();
  $('.product-mobile-zoom img').css({

  });
   $('.product-mobile-zoom').removeClass('close');
});

$('.product__thumbs--square #zoom').click(function(e){
  e.preventDefault();
  console.log('zoom');
  var src = $('.product__photo.slick-active').find('[data-zoom]').data('src');
  var height = 0;
  var width = 0;
  $('.product-mobile-zoom img').attr('src', src);
  
  var $draggable =  $('.product-mobile-zoom img').draggabilly();
  $('.product-mobile-zoom img').css({

  });
  $('.product-mobile-zoom').removeClass('close');
});

$('.product-mobile-zoom-close').click(function(){
  
 $('.product-mobile-zoom').addClass('close');
  $('.product-mobile-zoom img').draggabilly('destroy');
});


$('.reference-link').click(function(e){
  e.preventDefault();
  var referenceTab = $('[data-tab="references"]');
  var scrollTop = referenceTab.offset().top - 200;
  console.log(scrollTop);
  $(window).scrollTop(scrollTop);
  referenceTab.trigger('click');
  
});


$('.description-accordion-heading').click(function(e){
  var $parent_el = $(this).parents('.product-description-accordion');
  if($parent_el.hasClass('open')){
    $parent_el.removeClass('open');
    $('.description-accordion-child').slideUp(400);
  }else{
    $parent_el.addClass('open');
    $('.description-accordion-child').slideDown(400);
  }
});

//drawer init


window.onload = function() { 
  theme.Drawer.cartReloadPageRefresh(); 
  console.log('drawer loaded'); 
};



window.addEventListener( "pageshow", function ( event ) {
  var historyPage = event.persisted ||
  ( typeof window.performance != "undefined" &&
  window.performance.navigation.type === 2 );
  if ( historyPage ) {
    theme.Drawer.cartReloadPageRefresh(); 
    console.log('back drawer loaded');
  }
});

